import "./App.css";

import { ThemeProvider} from '@mui/material/styles';
import { Routes, Route } from "react-router-dom";
import { useRecoilState } from "recoil";
import { loggedUserAtom } from "./recoil/atoms";
import { ILoggedUser } from "./local-interfaces/local-interfaces";
import { useOnShortcuts } from "./hooks/useOnShortcuts";
import { SnackbarOrigin, SnackbarProvider } from "notistack";
import { Suspense, lazy } from "react";
import Loading from "./screens/Loading/Loading";
import KarrayMaterialTheme from "./theme/material/AppTheme";
import { CssBaseline, Box, Grid2 as Grid } from "@mui/material";
import MainLayout from "./screens/Layout/MainLayout";

// Lazy loading delle schermate
const Login = lazy(() => import("./screens/Login/Login"));
const Configuration = lazy(() => import("./screens/Configuration/Configuration"));
const Installations = lazy(() => import("./screens/Installations/InstallationsScreen"));
const EditDashboard = lazy(() => import("./screens/EditDashboard/EditDashboard"));
const PhonePreview = lazy(() => import("./screens/PhonePreview/PhonePreview"));
const EditComponent = lazy(() => import("./screens/EditComponent/EditComponent"));
const DocsScreen = lazy(() => import("./screens/Docs/DocsScreen"));
const FromCloud = lazy(() => import("./screens/FromCloud/FromCloud"));
const Notifications = lazy(() => import("./screens/Requests/Requests"));
const AdminToolScreen = lazy(() => import("./screens/AdminTool/AdminToolScreen"));
const DebugScreen = lazy(() => import("./screens/DebugTool/DebugScreen"));

const snackbarStyle: SnackbarOrigin = { horizontal: "right", vertical: "bottom" };

const App = () => {
  useOnShortcuts();
  const [loggedUser] = useRecoilState<ILoggedUser | undefined>(loggedUserAtom);

  return (
    <ThemeProvider theme={KarrayMaterialTheme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={5} anchorOrigin={snackbarStyle}>
        <Suspense fallback={<Loading />}>
          {loggedUser ? (
            <Grid container height={"100vh"} width={'100vw'} direction={'column'}>
              <Routes>
                <Route path="/" element={<MainLayout />} >
                  <Route index element={<Installations />} />
                  <Route path="/installations" element={<Installations />} />
                  <Route path="/installation/:installationId" element={<Configuration />} />
                  <Route path="/installation/:installationId/dashboard/:dashboardId" element={<EditDashboard />} />
                  <Route path="/installation/:installationId/dashboard/:dashboardId/component/:componentId" element={<EditComponent />} />
                  <Route path="/preview/:dashboardId" element={<PhonePreview />} />
                  <Route path="/docs/:nodeId/:docsSearchTerm" element={<DocsScreen />} />
                  <Route path="/plantFromCloud/:plantId" element={<FromCloud />} />
                  <Route path="/requests" element={<Notifications />} />
                  <Route path="/adminTool" element={<AdminToolScreen />} />
                  <Route path="/debug" element={<DebugScreen />} />
                  <Route path="*" element={<Login />} />
                </Route>
              </Routes>
            </Grid>
          ) : (
            <Box className="App">
              <Routes>
                <Route path="*" element={<Login />} />
                <Route path="/plantFromCloud/:plantId" element={<FromCloud />} />
              </Routes>
            </Box>
          )}
        </Suspense>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;